// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__3SIl_","header":"ReportDetails_header__2SaJ_","title":"ReportDetails_title__1jY_T","left":"ReportDetails_left__xe6AH"};